import { useState } from "react";
import { useAuth, friendlyInviteError } from "../lib/auth";

/** Post-sign-in failure surface: a settler signed in successfully but their
 *  invite redemption failed (e.g. the invite was exhausted between the click and
 *  the token mint). The token is committed regardless, so they're in — but their
 *  granted access may be missing. This dismissible note tells them so.
 *
 *  Only meaningful inside the AuthProvider (static/auth mode); live mode never
 *  mounts it. Renders nothing unless there is a token AND a failed outcome. */
export function InviteFailureBanner() {
  const { token, inviteOutcome } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;
  if (!token || inviteOutcome?.status !== "failed") return null;

  return (
    <div className="banner">
      Your invite couldn't be redeemed ({friendlyInviteError(inviteOutcome.reason)}). You're signed
      in, but access may be limited — get a fresh invite link and open it again.{" "}
      <button
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        style={{ textDecoration: "underline" }}
      >
        dismiss
      </button>
    </div>
  );
}
